import { ActionType, createAction } from "typesafe-actions";

export const navigateAction = createAction("app/navigate")<string>();
export const clearNavigateAction = createAction("app/clearNavigate")<void>();

export type NavigateActions = ActionType<typeof navigateAction> | ActionType<typeof clearNavigateAction>;
